module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "label": "Введите запрос",
      "hint": "Название, ИНН, руководитель, учредитель, адрес",
      "clearable": "",
      "persistent-hint": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Искать")])], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      attrs: {
        "value": _vm.cxt.activated(_vm.getItemKey(item)),
        "active-class": "v-list__tile--highlighted"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cxt.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n               " + _vm._s(_vm.renderHeads(item.ref)) + "\n               "), _c('br'), _vm._v("\n               ИНН: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnOrInnflHtml(item.ref.inn))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(_vm.formats.blank(item.ref.address)))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.accountId),
        expression: "item.accountId"
      }]
    }, [_vm._v("star")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.accountId),
        expression: "!item.accountId"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ref.clientId),
        expression: "item.ref.clientId"
      }]
    }, [_vm._v("person")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.ref.clientId),
        expression: "!item.ref.clientId"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('div', [_c(_vm.renderCompanyFlags(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('v-list-tile-action-text', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.ref.createDate, _vm.formats.formatDate)))])]), _vm._v("\n               Регистрация\n             ")], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26828ab6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientList.vue
// module id = 1014
// module chunks = 1